var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fs-adjustments"},[_c('fs-range-filter-wrapper',{attrs:{"routerLink":'/adjustments',"min":"-2","max":"2","defaultValue":"0","label":"menu.hue"},model:{value:(_vm.value.rotation),callback:function ($$v) {_vm.$set(_vm.value, "rotation", $$v)},expression:"value.rotation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }